import React from 'react';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();
  return (
    <div className="section-padding">
      <div className="container-custom">
        <h1 className="text-4xl font-bold mb-8">Welcome, {user?.user_metadata?.name || user?.email}!</h1>
        <div className="grid md:grid-cols-3 gap-6">
          {['Profile', 'Events', 'Donations'].map(item => (
            <div key={item} className="card p-6">
              <h3 className="text-xl font-bold mb-2">Your {item}</h3>
              <p className="text-gray-600">Manage your {item.toLowerCase()}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
